export default __webpack_public_path__ + "static/media/icon-search.b15ec837.svg";